import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["poemSection", "poemCard", "footer"]

  connect () {
    console.log("Poem controller connected");

    const poemSection = this.poemSectionTarget;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        poemSection.classList.remove("opacity-0");
        poemSection.classList.add("opacity-100");
      });
    });

    const hideFooter = this.hideFooter.bind(this);

    // Wait 2 seconds to ensure poem is fully rendered as image
    setTimeout(function() {
      hideFooter();
    }, 1000);

    window.onresize = hideFooter;
  }

  hideFooter () {
    const footer = this.footerTarget;
    const poemCard = this.poemCardTarget;
    const poemSection = this.poemSectionTarget;

    var poemCardBottom = poemCard.getBoundingClientRect().bottom;
    var footerTop = footer.getBoundingClientRect().top;

    if (footerTop < poemCardBottom) {
      footer.classList.add("opacity-0");
      poemSection.classList.remove("pb-28");
    } else {
      footer.classList.remove("opacity-0");
      poemSection.classList.add("pb-28");
    }
  }
}
